/**
 *
 * @returns An array of Seen diamonds ids.
 */
export const getSeenDiamonds = () => {
  if (typeof window !== 'undefined') {
    try {
      const storedDiamondIds = window.localStorage.getItem('seen-diamonds')
      if (storedDiamondIds) {
        const diamondIds = JSON.parse(storedDiamondIds) as number[]
        return diamondIds
      } else {
        return null
      }
    } catch (error) {
      // TODO: Cacth error with Sentry
      return null
    }
  } else {
    return null
  }
}

/**
 *
 * @param id This function saves a seen diamond to the local storage.
 */
export const saveSeenDiamond = (id: number) => {
  if (typeof window !== 'undefined') {
    try {
      const storedDiamondIds = window.localStorage.getItem('seen-diamonds')
      if (storedDiamondIds) {
        const diamondIds = JSON.parse(storedDiamondIds) as number[]
        if (!diamondIds.includes(id)) {
          const newDiamondIds = diamondIds.concat(id)
          window.localStorage.setItem(
            'seen-diamonds',
            JSON.stringify(newDiamondIds)
          )
        }
      } else {
        window.localStorage.setItem('seen-diamonds', JSON.stringify([id]))
      }
    } catch (error) {
      // TODO: Cacth error with Sentry
    }
  }
}
